import ReactPhoneInput, { PhoneInputProps } from "react-phone-input-2";
import 'react-phone-input-2/lib/plain.css'
import '../css/PhoneInput.css';
import { useTheme } from "../hooks/useTheme";

export default function PhoneInput(props: PhoneInputProps) {

    const { theme } = useTheme();

    return (
        <ReactPhoneInput 
            country={'br'} 
            preferredCountries={['br', 'pt']} 
            inputStyle={{ outlineColor: theme.color.primary }}
            {...props}/>
    );
}